export default __webpack_public_path__ + "static/media/Img_resume_agree_info.54b82c99.png";